import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ProvisionItem } from '../../models/provisionitem';

@Pipe({
  standalone: false,
  name: 'sortrecommendedexecutions'
})

@Injectable()
export class SortRecommendedExecutionsPipe implements PipeTransform {
  transform(items: ProvisionItem[], value: boolean): any[] {
    if (!items) return [];
    if (items.length === 0) return [];
    
    return items.filter(it => it.Type == 'FPC' && it.Recommended === value).sort( (a,b) => {
        if(a.Execution < b.Execution) return -1;
        else if(a.Execution > b.Execution) return 1;
      return 0;
    });
  }
}